import React from 'react'
import { SourcingSupplierStyled } from './styled'
import {
  Button,
  Modal,
  Image,
  InputSearch,
  Paginate,
  Section,
  SelectBox,
  Table,
  Input,
  Text,
  Spinner,
  Loading,
} from '../../components'
import { isEmpty } from 'lodash'
import { ICONS } from '../../themes'
import { ROUTE_PATH, STRING, toastFail } from '../../helpers'
import { mySupplierCompanyController } from '../../apiService'
import { connect } from 'react-redux'
import { dateMonDayYearTime } from '../../helpers/functions/format'
import { generatePath } from 'react-router'
import {
  filterSourcingSupplierInput1,
  filterSourcingSupplierOptions2,
  filterSourcingSupplierOptions3,
  filterSourcingSupplierOptions4,
  filterSourcingSupplierOptionsEventType,
} from '../../store/actions'
import { store } from 'store'
import NumberFormat from 'react-number-format'
import moment from 'moment/moment'

const eventTypes = [
  {
    value: 0,
    label: 'All Event Type',
  },
  {
    value: 1,
    label: 'RFQ',
  },
  {
    value: 2,
    label: 'Auction',
  },
]

const options = [
  { value: '0', label: 'All' },
  { value: '3', label: 'Admin' },
  { value: '4', label: 'User' },
]

const matchValueSelected = (option, selectedId) => {
  return option.find(value => value.value.toString() === selectedId.toString()) // {value: '',text:''}
}

export class SourcingSupplierContainers extends React.Component {
  _isMounted = false
  _searchDelay = false

  constructor(props) {
    super(props)

    const { state = {} } = this.props.location

    this.state = {
      eventName: state.eventName || '',
      eventTypeId: state.eventTypeId || 0,
      buyerId: state.buyerId || 0,
      statusId: state.statusId || '0',
      responseStatusId: state.responseStatusId || 0,
      searchPage: 1,
      activePage: 1,
      searchValue: '',
      listSupplier: [],
      resultRFQ: {
        page: 1,
        limit: 10,
      },
      modals: [
        { name: 'history', isOpen: false },
        { name: 'delete', isOpen: false, Idlist: '', Fullname: '' },
      ],
      statuses: [],
      responseStatuses: [],
      buyerNameStatuses: [],
      history: [],
      isSortBy: [
        { name: 'event_no', value: undefined },
        { name: 'event_name', value: undefined },
      ],
      sortFiedName: '',
      orderBy: 'asc',
      isMount: true,
      loaderHistory: false,
    }
    this.getRFQSupplierListDefault = this.getRFQSupplierListDefault.bind(this)
    this.renderSourcingSupplier = this.renderSourcingSupplier.bind(this)
    this._isMounted = true
  }

  toggleModal = (evt, id, name) => {
    this.setState(prevState => ({
      ...prevState,
      modals: prevState.modals.map(modal => ({
        ...modal,
        isOpen: modal.name === evt ? !modal.isOpen : false,
        Idlist: id,
        Fullname: name,
      })),
    }))
  }
  static getDerivedStateFromProps = (props, state) => {
    const funcGetParams = () => {
      const params = props.location.state
      if (params) {
        if (params.status) {
          const paramsStatus = parseInt(params.status)
          store.dispatch(filterSourcingSupplierOptions2(paramsStatus, true))
        }
      }
    }
    try {
      funcGetParams()
    } catch (error) {
      console.log(error)
    }
    return null
  }
  componentDidMount() {
    if (this._isMounted) {
      this.getEventStatus()
      this.getResponseStatus()
      this.getBuyerStatuses()
      this.getRFQSupplierList()
    }
  }

  onChangeFilter(key = '', element = null) {
    const value = element.target ? element.target.value : element.value

    let getListFunc = () => {
      if (!this._searchDelay) this.getRFQSupplierList()
    }

    if (key in this.state) {
      if (key === 'eventName') {
        this._searchDelay = true
        this.searchDelay = setTimeout(() => {
          this._searchDelay = false
        }, 500)
      }

      this.setState({ [key]: value }, getListFunc.bind(this))
    }
  }

  getRFQSupplierList = async page => {
    const { resultRFQ, sortFiedName, orderBy } = this.state
    const params = {
      limit: resultRFQ.limit,
      page: page ? page : resultRFQ.page,
      eventName: this.state.eventName.trim(),
      statusId: this.state.statusId,
      responseStatusId: this.state.responseStatusId,
      buyerId: this.state.buyerId,
      sort_by: sortFiedName,
      sort_direction: orderBy,
      event_type_id: this.state.eventTypeId,
    }

    console.log('getRFQSupplierList', params)

    const res = await mySupplierCompanyController().getRFQSupplierList(params)
    if (res) {
      const filterSuppliersIsCancel = this.filterSupplierListStatusCancel(
        res.records,
        this.props.searchOptionSourcingSupplierFilter2
      )
      this.setState({
        resultRFQ: res,
        listSupplier: filterSuppliersIsCancel,
        activePage: page ? page : resultRFQ.page,
      })
    } else {
      toastFail('error')
    }
  }
  getRFQSupplierListDefault = async status => {
    const {
      resultRFQ,
      eventName,
      buyerId,
      statusId,
      responseStatusId,
      sortFiedName,
      orderBy,
    } = this.state
    const DEFAULT_STATUS_ID = '0'
    const params = {
      limit: resultRFQ.limit,
      page: resultRFQ.page,
      eventName: '',
      statusId: status,
      responseStatusId: this.props.searchOptionSourcingSupplierFilter3,
      buyerId: this.props.searchOptionSourcingSupplierFilter4,
      sort_by: sortFiedName,
      sort_direction: orderBy,
      event_type_id: 0,
    }
    const res = await mySupplierCompanyController().getRFQSupplierList(params)
    if (res) {
      const filterSuppliersIsCancel = this.filterSupplierListStatusCancel(
        res.records,
        this.props.searchOptionSourcingSupplierFilter2
      )
      this.setState({ resultRFQ: res, listSupplier: filterSuppliersIsCancel })
    } else {
      toastFail('error')
    }
  }
  filterSupplierListStatusCancel = (suppliers = [], statusId = '') => {
    const status_Id = statusId.toString()
    const filterIsCancel = suppliers.filter(data => {
      const eventCancel =
        data.is_cancel === true && (status_Id === '5' || status_Id === '0')
      const eventNotCancel = data.is_cancel === false && status_Id !== '5'
      if (eventCancel) {
        return data
      } else if (eventNotCancel) {
        return data
      }
    })
    return filterIsCancel
  }

  getEventStatus = async () => {
    const res = await mySupplierCompanyController().getEventStatus()
    if (res) {
      let option = []
      res.map(e => {
        const data = { value: e.id, label: e.name }
        option.push(data)
      })
      this.setState({ statuses: option })
    }
  }

  getResponseStatus = async () => {
    const res = await mySupplierCompanyController().getResponseStatus()
    if (res) {
      let option = []
      res.map(e => {
        const data = { value: e.id, label: e.name }
        option.push(data)
      })
      this.setState({ responseStatuses: option })
    }
  }

  getBuyerStatuses = async () => {
    const res = await mySupplierCompanyController().getBuyerStatuses()
    if (res) {
      let option = []
      res.map(e => {
        const data = { value: e.id, label: e.full_name }
        option.push(data)
      })
      this.setState({ buyerNameStatuses: option })
    }
  }

  getSupplierHistory = async event_id => {
    this.setState({ loaderHistory: true })
    if (event_id) {
      let res = await mySupplierCompanyController().getSupplierHistory(event_id)
      if (res) {
        this.toggleModal('history')
        this.setState({ history: res, loaderHistory: false })
      } else {
        toastFail('error')
      }
    }
  }

  changePage = e => {
    this.getRFQSupplierList(e)
    this.setState({ activePage: e })
  }

  matchValue = (option, selectedId, IsStatusCancel = '0') => {
    const matchOption = option.find(
      value => value.value.toString() === selectedId.toString()
    )
    if (matchOption) {
      return IsStatusCancel === '0' ? matchOption.label : 'Cancelled'
    }
  }

  renderStatus = (statusID = '', isCancel = '') => {
    switch (true) {
      case isCancel === true:
        return <p className="info-status">Cancelled</p>
      case statusID === 3 && isCancel === false:
        return <p className="success-status">Open</p>
      case statusID === 4 && isCancel === false:
        return <p className="info-status">Closed</p>
      default:
        break
    }
  }

  renderStatusAuction = (statusID = '', isCancel = '', status = '') => {
    switch (true) {
      case isCancel === true:
        return <p className="info-status">Cancelled</p>
      case statusID === 2 && isCancel === false:
        return <p className="pending-status">{status}</p>
      case statusID === 3 && isCancel === false:
        return <p className="success-status">{status}</p>
      case statusID === 4 && isCancel === false:
        return <p className="info-status">Closed</p>
      default:
        break
    }
  }

  findSortBy = evt => {
    let sortBy = ''
    this.state.isSortBy.find(column => {
      if (column.name === evt && column.value == undefined) {
        sortBy = 'desc'
      } else if (column.name === evt && column.value == 'asc') {
        sortBy = 'desc'
      } else if (column.name === evt && column.value == 'desc') {
        sortBy = 'asc'
      }
      return sortBy
    })
    return sortBy
  }

  toggleSort = evt => {
    const orderBy = this.findSortBy(evt)
    const sortFiedName = evt
    this.setState(
      prevState => {
        const isSortBy = prevState.isSortBy.map(column => ({
          ...column,
          value:
            column.name === evt
              ? column.value !== undefined
                ? column.value === 'asc'
                  ? 'desc'
                  : 'asc'
                : 'desc'
              : undefined,
        }))
        return { ...prevState, isSortBy, orderBy, sortFiedName }
      },
      () => {
        this.getRFQSupplierList()
      }
    )
  }

  filterSortByValue = evt => {
    return this.state.isSortBy
      .filter(columns => columns.name === evt)
      .map(column => column.value)[0]
  }

  renderStartDateEndDate = (date = {}) => {
    return (
      <Section>
        ( Start date: {dateMonDayYearTime(date.start_date)}
        <br />
        End date: {dateMonDayYearTime(date.end_date)} )
      </Section>
    )
  }

  rfqHistoryReopenRescheduleShowStartDateEndDate = (rh = {}) => {
    const reOpen = rh.action_history_type === 'Re-Open'
    const reSchedule = rh.action_history_type === 'Re-Schedule'

    if (reOpen || reSchedule) {
      const date = {
        start_date: rh.start_date,
        end_date: rh.end_date,
      }
      return this.renderStartDateEndDate(date)
    }
  }

  onChangeEvent = event => {
    store.dispatch(filterSourcingSupplierInput1(event.target.value))
    // this.setState({ eventName: event.target.value })
  }

  onEnterSearch = event => {
    if (event.key === 'Enter') {
      store.dispatch(filterSourcingSupplierInput1(event.target.value, true))
      this.getRFQSupplierList()
    }
  }

  onClearSearch = (key = '', element = null) => {
    const value = element.target ? element.target.value : element.value

    this.setState({ [key]: value }, () => {
      store.dispatch(filterSourcingSupplierInput1(event.target.value, true))
      this.getRFQSupplierList()
    })
  }
  renderSourcingSupplier = () => {
    const {
      modals,
      listSupplier,
      statuses,
      resultRFQ,
      responseStatuses,
      buyerNameStatuses,
      activePage,
      history,
    } = this.state
    const renderPageTitle = () => {
      const handlerClickBreadcrumb = e => {
        return this.props.history.push(ROUTE_PATH.HOME.LINK)
      }
      return (
        <Section className="page-topbar">
          <Section className="page-header">
            <Section className="page-icon">
              <Image
                id="page_icon_user_management"
                src={ICONS['icon-sourcing-white.svg']}
                alt="page icon"
              />
            </Section>
            <Section className="title-and-breadcrumb">
              <Section id="page_title_user_management" className="title">
                Sourcing
              </Section>

              <Section
                id="page_breadcrumb_user_management"
                className="breadcrumbs"
              >
                <Button className="breadcrumb" onClick={handlerClickBreadcrumb}>
                  <span>{STRING.HOME}</span>
                </Button>

                <Button className="breadcrumb current">
                  <span>Sourcing</span>
                </Button>
              </Section>
            </Section>
          </Section>
        </Section>
      )
    }
    const renderPageContent = () => {
      const funcOnChangeEvent = e => {
        return this.onChangeEvent(e)
      }
      const funcOnEnterSearch = e => {
        return this.onEnterSearch(e)
      }
      const funcOnClearSearch = e => {
        return this.onClearSearch()
      }
      const funcOnChangeResultRFQ = event => {
        resultRFQ.page = 1
        store.dispatch(filterSourcingSupplierOptions2(event.value, true))
        return this.setState({ resultRFQ }, this.getRFQSupplierList)
      }
      const funcOnChangeEventTypeFilter = event => {
        resultRFQ.page = 1
        store.dispatch(
          filterSourcingSupplierOptionsEventType(event.value, true)
        )
        return this.setState({ resultRFQ }, this.getRFQSupplierList)
      }

      const funcOnChangeResponseStatus = event => {
        resultRFQ.page = 1
        store.dispatch(filterSourcingSupplierOptions3(event.value, true))
        return this.setState({ resultRFQ }, this.getRFQSupplierList)
      }
      const funcOnChangeBuyerStatusFilter = event => {
        resultRFQ.page = 1
        store.dispatch(filterSourcingSupplierOptions4(event.value, true))
        return this.setState({ resultRFQ }, this.getRFQSupplierList)
      }
      const funcOnClickEventNo = e => {
        return this.toggleSort('event_no')
      }
      const funcRenderListSupplier = () => {
        if (listSupplier) {
          const funcRenderRfqStatus = e => {
            const then = new Date(e.start_date)
            const dayDiff = moment(then).diff(moment(), 'days')
            let dateWithin24
            // console.log('dayDiff', dayDiff)
            if (dayDiff >= 1) {
              dateWithin24 = false
              // console.log('date is NOT within 24 hours')
            } else {
              dateWithin24 = true
              // console.log('date is within 24 hours')
            }
            if (e.status === 'Cancelled') {
              return (
                <Image
                  className="detail-icon"
                  src={ICONS['icon-detail.svg']}
                  alt="View"
                  tootipValue={`View`}
                  useTootipFor="View"
                  useTootip={true}
                />
              )
            } else if (e.status === 'Closed') {
              return (
                <Image
                  className="detail-icon"
                  src={ICONS['icon-detail.svg']}
                  alt="View"
                  tootipValue={`View`}
                  useTootipFor="View"
                  useTootip={true}
                />
              )
            } else if (e.event_type_id === 2 && dateWithin24) {
              //เช็ค Auction เพิ่ม
              return (
                <Image
                  className="detail-icon"
                  src={ICONS['icon-detail.svg']}
                  alt="View"
                  tootipValue={`View`}
                  useTootipFor="View"
                  useTootip={true}
                />
              )
            } else if (
              e.event_type_id === 2 &&
              e.status.includes('Open') &&
              e.status_id === 3
            ) {
              return (
                <Image
                  className="detail-icon"
                  src={ICONS['icon-detail.svg']}
                  alt="View"
                  tootipValue={`View`}
                  useTootipFor="View"
                  useTootip={true}
                />
              )
            } else {
              return (
                <Image
                  className="edit-icon"
                  src={ICONS['icon-edit.svg']}
                  alt="Edit"
                  tootipValue={`Edit`}
                  useTootipFor="Edit"
                  useTootip={true}
                />
              )
            }
          }
          const funcAwardStatusClass = e => {
            if (e.supplier_response_status_id === 4) {
              return `pending-status`
            } else if (e.supplier_response_status_id === 5) {
              return `success-status`
            } else if (e.supplier_response_status_id === 6) {
              return `rejected-status`
            } else {
              return 'info-status'
            }
          }
          const funcRenderResponseStatus = e => {
            if (
              e.supplier_response_status_id === '4' ||
              e.supplier_response_status_id === '5' ||
              e.supplier_response_status_id === '6'
            ) {
              return this.matchValue(
                responseStatuses,
                e.supplier_response_status_id
              )
            } else {
              return e.supplier_response_status
            }
          }
          const funcLinkActions = e => {
            const path = generatePath(
              ROUTE_PATH.SOURCING_DETAIL_SUPPLIER_FORM.LINK,
              { id: e.id }
            )
            return this.props.history.push({
              pathname: path,
            })
          }
          const funcRenderButtonAuction = e => {
            if (e.event_type === 'Auction') {
              return (
                <Button
                  className="link"
                  onClick={() => {
                    this.props.history.push(
                      `/sourcing-auction-supplier/${e.sourcing_id}`
                    )
                  }}
                >
                  <Image
                    className="Auction-icon"
                    src={ICONS['icon-hammer-blue.svg']}
                    alt="Auction"
                    tootipValue={`Auction`}
                    useTootipFor="Auction"
                    useTootip={true}
                  />
                </Button>
              )
            } else {
              return null
            }
          }
          return listSupplier.map((e, i) => {
            return (
              <Table.TR key={i}>
                <Table.TD>
                  <Text
                    tootipValue={e.event_no}
                    useTootipFor="event-no"
                    useTootip={true}
                  >
                    {e.event_no}
                  </Text>
                </Table.TD>
                <Table.TD>
                  <Text
                    tootipValue={e.event_name}
                    useTootipFor="event-name"
                    useTootip={true}
                  >
                    {e.event_name}
                  </Text>
                </Table.TD>

                <Table.TD>
                  <Text
                    tootipValue={e.buyer_name}
                    useTootipFor="buyer-name"
                    useTootip={true}
                  >
                    {e.buyer_name}
                  </Text>
                </Table.TD>

                <Table.TD>
                  <Text
                    tootipValue={e.event_type}
                    useTootipFor="event-type"
                    useTootip={true}
                  >
                    {e.event_type}
                  </Text>
                </Table.TD>

                <Table.TD>
                  {e.event_type_id === 1 &&
                    this.renderStatus(e.status_id, e.is_cancel)}
                  {e.event_type_id === 2 &&
                    this.renderStatusAuction(
                      e.status_id,
                      e.is_cancel,
                      e.status
                    )}
                </Table.TD>

                <Table.TD>
                  <p className={funcAwardStatusClass(e)}>
                    {funcRenderResponseStatus(e)}
                  </p>
                </Table.TD>

                <Table.TD>
                  <div>{dateMonDayYearTime(e.start_date)}</div>
                </Table.TD>

                <Table.TD>
                  <div>{dateMonDayYearTime(e.end_date)}</div>
                </Table.TD>

                <Table.TD>
                  <Text
                    tootipValue={e.supplier}
                    useTootipFor="supplier"
                    useTootip={true}
                  >
                    {e.supplier}
                  </Text>
                </Table.TD>

                <Table.TD className="actions w-150">
                  <Section>
                    {e.status_id === 3 &&
                      e.supplier_response_status_id === 5 &&
                      funcRenderButtonAuction(e)}

                    <Button className="link" onClick={() => funcLinkActions(e)}>
                      {funcRenderRfqStatus(e)}
                    </Button>

                    <Button
                      className="link"
                      onClick={() => {
                        this.getSupplierHistory(e.id)
                      }}
                    >
                      <Image
                        className="history-icon"
                        src={ICONS['icon-history.svg']}
                        alt="History"
                        tootipValue={`History`}
                        useTootipFor="History"
                        useTootip={true}
                      />
                    </Button>
                  </Section>
                </Table.TD>
              </Table.TR>
            )
          })
        }
      }
      const funcListSupplierIcon = () => {
        if (isEmpty(listSupplier)) {
          return (
            <Section className="no-result-found">
              <Image src={ICONS['icon-ssr.png']} className="no-result" />
              <p>No result found</p>
            </Section>
          )
        }
      }
      const funcShowingResultRFQ = () => {
        if (isEmpty(listSupplier)) {
          return '0'
        } else {
          if (resultRFQ.offset === 0) {
            return '1'
          } else {
            return resultRFQ.offset + 1
          }
        }
      }
      const funcToResultRFQ = () => {
        const offset = resultRFQ.offset + resultRFQ.limit
        if (offset > resultRFQ.total_record) {
          return resultRFQ.total_record
        } else if (isEmpty(listSupplier)) {
          return '0'
        } else {
          return offset
        }
      }
      const handlerOnChangePaginate = e => {
        return this.changePage(e)
      }
      const handlerOnChangeNumberFormat = e => {
        return this.setState({ searchPage: parseInt(e.target.value) })
      }
      const funcisAllowedNumberFormat = values => {
        const { value, floatValue } = values
        if (value == 0 && value !== '') {
          return false
        }
        if (typeof floatValue === 'undefined' || typeof value === 'undefined') {
          return true
        }
        if (value.charAt(0) === '0') {
          if (value.charAt(1) && value.charAt(1) != '.') {
            return false
          }
        }
        if (this.props.maximum) {
          return floatValue <= this.props.maximum
        } else {
          return true
        }
      }
      const funcOnClickGo = e => {
        return this.changePage(this.state.searchPage)
      }
      return (
        <Section className="main-content">
          <Section className="content-body">
            <Section className="table-filter">
              <InputSearch
                id="filter_search_input"
                placeholder="Event No., Event Name"
                name="searchValue"
                value={this.state.eventName}
                clear={true}
                onChange={e => this.onChangeFilter('eventName', e)}
                onKeyDown={funcOnEnterSearch}
                onClickSearchClear={() =>
                  this.onClearSearch('eventName', {
                    target: { value: '' },
                  })
                }
              />
              <SelectBox
                id="event_type_filter"
                className="table-filter"
                options={eventTypes}
                placeholder="All Event Type"
                isSearchable={false}
                isClearable={false}
                value={matchValueSelected(eventTypes, this.state.eventTypeId)}
                onChange={e => this.onChangeFilter('eventTypeId', e)}
              />
              <SelectBox
                id="even_status_filter"
                className="table-filter"
                options={statuses}
                placeholder="All Event Status"
                isSearchable={false}
                isClearable={false}
                value={matchValueSelected(statuses, this.state.statusId)}
                onChange={e => this.onChangeFilter('statusId', e)}
              />

              <SelectBox
                id="response_status_filter"
                className="table-filter"
                options={responseStatuses}
                placeholder="All Response Status"
                isSearchable={false}
                isClearable={false}
                value={matchValueSelected(
                  responseStatuses,
                  this.state.responseStatusId
                )}
                onChange={e => this.onChangeFilter('responseStatusId', e)}
              />

              <SelectBox
                id="buyer_status_filter"
                className="table-filter"
                options={buyerNameStatuses}
                placeholder="Buyer Name"
                isSearchable={false}
                isClearable={false}
                value={matchValueSelected(
                  buyerNameStatuses,
                  this.state.buyerId
                )}
                onChange={e => this.onChangeFilter('buyerId', e)}
              />
            </Section>

            <Section className="table-responsive table-wrapper">
              <Table className="user split-row-color">
                <Table.THEAD>
                  <Table.TR className="header">
                    <Table.TH
                      id="event_no"
                      isSortable={true}
                      sortBy={this.filterSortByValue('event_no')}
                      onClick={funcOnClickEventNo}
                    >
                      EVENT NO.
                    </Table.TH>

                    <Table.TH>EVENT NAME</Table.TH>

                    <Table.TH>BUYER NAME</Table.TH>

                    <Table.TH>EVENT TYPE</Table.TH>

                    <Table.TH>EVENT STATUS</Table.TH>

                    <Table.TH>RESPONSE STATUS</Table.TH>

                    <Table.TH>START DATE</Table.TH>

                    <Table.TH>END DATE</Table.TH>

                    <Table.TH id="created_by">RESPONSE BY</Table.TH>

                    <Table.TH className="actions w-150" id="actions_header">
                      ACTIONS
                    </Table.TH>
                  </Table.TR>
                </Table.THEAD>
                <Table.TBODY>{funcRenderListSupplier()}</Table.TBODY>
                {funcListSupplierIcon()}
              </Table>
            </Section>
          </Section>

          <Section className="content-footer">
            <Section className="showing-item">
              Showing {funcShowingResultRFQ()} to {funcToResultRFQ()} of{' '}
              {resultRFQ.total_record} entries
            </Section>

            <Section className="paginate-wrapper">
              <Paginate
                activePage={activePage}
                itemsCountPerPage={resultRFQ.limit}
                totalItemsCount={resultRFQ.total_record}
                onChange={handlerOnChangePaginate}
              />

              <Section className="moveto-wrapper">
                <NumberFormat
                  label="Page"
                  isHorizontal
                  className="paginate-moveto"
                  defaultValue="1"
                  maxLength="4"
                  customInput={Input}
                  decimalSeparator={false}
                  allowNegative={false}
                  allowLeadingZeros={false}
                  onChange={handlerOnChangeNumberFormat}
                  isAllowed={funcisAllowedNumberFormat}
                />
                <Button onClick={funcOnClickGo}>go</Button>
              </Section>
            </Section>
          </Section>
        </Section>
      )
    }
    const funcModalDelete = () => {
      const funcOpenModal = () => {
        const openModals = modals
          .filter(modal => {
            return modal.name === 'delete'
          })
          .map(obj => obj.isOpen)[0]
        return openModals
      }
      const openModal = funcOpenModal()
      const funconClickHistory = e => {
        this.toggleModal('delete')
        return document.body.classList.remove('modal-open')
      }
      const funcOnClickConfirm = () => {
        return this.deleteList()
      }
      return (
        <Modal
          id="delete_id"
          className="theme-blue"
          isOpen={openModal}
          modalWidth="575px"
        >
          <Modal.Header>Delete</Modal.Header>

          <Modal.Body>
            <p className="default text-center">
              Are you sure to delete? <br />
              {modals[0].FullName}
            </p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              id="close_modal_history_id"
              className="theme-border-gray"
              onClick={funconClickHistory}
            >
              Cancel
            </Button>

            <Button
              id="close_modal_history_id"
              className="theme-green"
              onClick={funcOnClickConfirm}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }
    const funcModalHistoryLog = () => {
      const funcModalIsOpen = () => {
        const openModals = modals
          .filter(modal => {
            return modal.name === 'history'
          })
          .map(obj => obj.isOpen)[0]
        return openModals
      }
      const isOpen = funcModalIsOpen()
      const funcRenderHistory = () => {
        if (history) {
          const funcRenderActionHistoryType = e => {
            if (e.action_history_type.includes('Reject') && !e.is_system) {
              return <Section>Reason: {e.reason}</Section>
            } else {
              return ''
            }
          }
          const funcRenderRoleName = e => {
            if (e.is_system) {
              return e.role_name
            }
          }
          const funcRenderActionBy = e => {
            if (e.is_system) {
              return 'System'
            } else {
              return e.action_by
            }
          }
          return history.map((e, i) => {
            return (
              <Table.TR key={i}>
                <Table.TD className="create-date">
                  {dateMonDayYearTime(e.created_at)}
                </Table.TD>
                <Table.TD className="detail">
                  {e.action_history_type}
                  {funcRenderActionHistoryType(e)}
                  {this.rfqHistoryReopenRescheduleShowStartDateEndDate(e)}
                </Table.TD>

                <Table.TD className="action">
                  <Section>{funcRenderRoleName(e)}</Section>
                  <Section>{funcRenderActionBy(e)}</Section>
                </Table.TD>
              </Table.TR>
            )
          })
        }
      }
      const funcOnClickCloseModal = e => {
        return this.toggleModal()
      }
      return (
        <Modal
          id="history_id"
          className="history-log theme-blue"
          isOpen={isOpen}
        >
          <Modal.Header>History Log</Modal.Header>

          <Modal.Body>
            {this.state.loaderHistory ? (
              <Spinner />
            ) : (
              <Section className="table-header-freeze-wrapper">
                <Table className="history-log-data">
                  <Table.TBODY>
                    <Table.TR>
                      <Table.TH className="create-date">DATE</Table.TH>
                      <Table.TH className="detail">ACTIVITY</Table.TH>

                      <Table.TH className="action">ACTION BY</Table.TH>
                    </Table.TR>
                  </Table.TBODY>
                </Table>

                <Table className="history-log-data split-row-color">
                  <Table.TBODY>{funcRenderHistory()}</Table.TBODY>
                </Table>
              </Section>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button
              id="close_modal_history_id"
              className="theme-gray close"
              onClick={funcOnClickCloseModal}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }
    return (
      <React.Fragment>
        <SourcingSupplierStyled>
          {renderPageTitle()}
          {renderPageContent()}
        </SourcingSupplierStyled>
        {funcModalDelete()}
        {funcModalHistoryLog()}
      </React.Fragment>
    )
  }
  render = () => this.renderSourcingSupplier()
}

const mapStateToProps = state => {
  const {
    searchSourcingSupplierInput,
    enterSourcingSupplierFilter,
  } = state.searchInputFilterSourcingSupplier
  const {
    searchOptionSourcingSupplierFilter2,
    selectedSourcingSupplierOptions2,
  } = state.searchSelectOptionSourcingSupplier2
  const {
    searchOptionSourcingSupplierFilter3,
    selectedSourcingSupplierOptions3,
  } = state.searchSelectOptionSourcingSupplier3
  const {
    searchOptionSourcingSupplierFilter4,
    selectedOptionsSourcingSupplier4,
  } = state.searchSelectOptionSourcingSupplier4
  const {
    searchOptionSourcingSupplierFilterEventType,
    selectedOptionsSourcingSupplierEventType,
  } = state.searchSelectOptionSourcingSupplierEventType
  return {
    role: state.role,
    user: state.user,
    searchSourcingSupplierInput,
    enterSourcingSupplierFilter,
    searchOptionSourcingSupplierFilter2,
    selectedSourcingSupplierOptions2,
    searchOptionSourcingSupplierFilter3,
    selectedSourcingSupplierOptions3,
    searchOptionSourcingSupplierFilter4,
    selectedOptionsSourcingSupplier4,
    searchOptionSourcingSupplierFilterEventType,
    selectedOptionsSourcingSupplierEventType,
  }
}
export const SourcingSupplierContainer = connect(mapStateToProps)(
  SourcingSupplierContainers
)

export default SourcingSupplierContainer
